<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-user-secret"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.groupAbility.edit.title') }}</h1>
      </div>
      <div class='popup__form'>
        <form @submit.prevent="editRole" class="form" id="editRoleForm">
          <Entry v-model="name" required indicator="form.name"></Entry>
           <div class="form__group">
            <div class="form__group-content">
              <textarea class="roles__textarea roles__descriptif" :class="manageEntry('input')" v-model="descriptif" :placeholder="$t('form.descriptive.placeholder')" @focusout="isFocusOut = true"></textarea>
              <svg v-show="isFocusOut" :class="manageEntry('svgclass')">
                <use :href="manageEntry('svgpath')"></use>
              </svg>
            </div>
           </div>
        </form>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="editRoleForm" @click='close'>{{ $t('popup.groupAbility.edit.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="editRoleForm">{{ $t('popup.groupAbility.edit.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import Entry from '@/components/Entry'
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

import iconSVG from '@/assets/sprite.svg'

export default {
  data: function () {
    return {
      name: '',
      descriptif: '',
      isFocusOut: false
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  props: ['role'],
  mounted () {
    this.getRoleInfos()
  },
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('groupAbility/SHOW_EDIT_GROUPABILITY_POPUP', false)
    },
    getRoleInfos () {
      const { name, descriptif } = this.role

      this.name = name
      this.descriptif = descriptif
    },
    async editRole () {
      const { name, descriptif } = this

      try {
        await HTTP_CLIENT.patch(`groupability/${this.role._id}`, {
          name,
          descriptif
        })
        this.sendSuccessToast(this.$t('feedback-ok.groupAbility.edit', { name }))
        this.close()
      } catch (error) { console.log(error) }
    },
    manageEntry (widget) {
      if (widget === 'input' && this.isFocusOut) return { 'roles__textarea--success': 'true' }
      if (widget === 'svgclass') return { 'form__icon--success': 'true' }
      if (widget === 'svgpath') return `${iconSVG}#icon-check-circle`
    }
  }
}
</script>
